import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import routes from "./routes_data";
import PrivateRoute from "./private";
import PublicRoute from "./public";
import InactivityLogout from "../custom_utilities/custom_logout/InactivityLogout";
import { connect } from "react-redux";
import BlockedtoAccessApp from "../containers/blocking_access_to_app/BlockedtoAccessApp";
import Footer from "../containers/homepage/Footer/Footer";
import All_page_content from "../containers/homepage/All_page_tabing/All_page_content";
import { Store } from "../containers/homepage/Store/Store";
import PackagesOverview from "../containers/homepage/Store/PackagesOverview/PackagesOverview";

const basename = "/";

// ✅ A wrapper component to use useLocation inside <Router>
const RoutesWithMeta = ({ blockedData, isLoginOpen, setIsLoginOpen }) => {
  const location = useLocation();
  const isHomepage = location.pathname === "/";

  return (
    <>
      {/* ✅ Inject robots meta tag only on non-home pages */}
      <Helmet>
        {!isHomepage && (
          <meta name="robots" content="noindex, nofollow" />
        )}
      </Helmet>

      <InactivityLogout />
      <Switch>
        {routes.map((route, i) => {
          const RouteComponent = route.auth ? PrivateRoute : PublicRoute;
          return (
            <RouteComponent
              key={i}
              path={route.path}
              exact={route.exact}
              component={route.component}
              isBlocked={blockedData?.show_popup}
            />
          );
        })}

        {blockedData?.show_popup && (
          <Route path="/block" component={BlockedtoAccessApp} />
        )}
        <Route path="/aboutUs">
          <All_page_content tab="AboutUs" />
        </Route>
        <Route path="/privacyPolicy">
          <All_page_content tab="privacyPolicy" />
        </Route>
        <Route path="/terms">
          <All_page_content tab="terms" />
        </Route>
        <Route
          path="/store"
          render={(props) => (
            <Store
              {...props}
              setIsLoginOpen={setIsLoginOpen}
              isLoginOpen={isLoginOpen}
            />
          )}
        />
        <Route
          path="/login-store/:target_id/:class_id"
          render={(props) => (
            <Store
              {...props}
              setIsLoginOpen={setIsLoginOpen}
              isLoginOpen={isLoginOpen}
            />
          )}
        />
        <Route
          path="/packages-overview/:package_id"
          component={PackagesOverview}
        />
        <Route path="/" exact />
      </Switch>
    </>
  );
};

// ✅ Outer Router component to contain <Router>
const Routes = (props) => {
  return (
    <Router basename={basename}>
      <RoutesWithMeta {...props} />
    </Router>
  );
};

const mapStateToProps = (state) => ({
  blockedData: state.BlockUserSlice.blockedData,
});

export default connect(mapStateToProps, null)(Routes);
